import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Header from "./../layouts/header";
import Footer from "./../layouts/footer";
function LegalDisclaimer() {
  useEffect(() => {
    window.scrollTo({
      behavior: "smooth",
      top: 0,
    });
  }, []);
  const dynamicClassName = "footer_section custom_footer_style";
  return (
    <>
      <Header />
      <div className="termsWrapper">
        <div className="termsContent">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="termsComponent">
                  <h3 className="topTermsHeading">Legal Disclaimer </h3>
                  <p className="topParas">
                    Your use of this Site and the Terms and Conditions stated in this policy shall be governed by the laws of India. In the event of any disputes arising out of or in connection with the use of the Website, the courts at Gurgaon, Haryana shall have exclusive jurisdiction.
                  </p>
                  <p className="topParas">
                    Finlab.one makes no representations or warranties regarding the accuracy, reliability, completeness, currency, or timeliness of any content, information, software, text, graphics, links, or communications provided on or through the Site. Finlab.one does not warrant that the operation of the Site will be error-free or uninterrupted. Accordingly, Finlab.one shall not be liable for any monetary or other loss or damage suffered by you due to any delay, failure, interruption, or corruption of data or other information transmitted in connection with the use of the Site, or due to any interruption or errors in the operation of the Website.
                  </p>
                  <p className="topParas">
                    You are responsible for taking appropriate precautions to ensure that any content you access or download is free from viruses, worms, Trojan horses, or other harmful or destructive elements.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer className={dynamicClassName} />
    </>
  );
}
export default LegalDisclaimer;
